import(/* webpackMode: "eager" */ "/repo/apps/web/app/global-error.tsx");
